<template>
  <component
    :is="routeTo ? 'router-link' : 'div'"
    :to="routeTo"
    class="btn-menu"
    @click="onClick"
  >
    <div
      class="btn-menu__wrapper pointer-events-none"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <div class="btn-menu__wrapper__text">
        {{ text }}
      </div>
      <div
        v-if="checkWeekend"
        class="btn-menu__wrapper__note"
      >
        {{ checkWeekend }}
      </div>
    </div>
  </component>
</template>

<script>
import mixinWeekend from "../../misc/mixinWeekend";

export default {
  name: "ButtonMenu",
  mixins: [mixinWeekend],
  props: {
    routeTo: {
      type: Object,
      default: null,
    },
    text: {
      type: String,
      default: "Button",
    },
  },
  data() { return {} },
  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/style";

.btn-menu {
  max-width: 100%;
  color: white;
  text-align: center;
  background-color: $color-base;
  transition: all ease-in-out 0.3s;
  -moz-transition: all ease-in-out 0.3s;
  -webkit-transition: all ease-in-out 0.3s;
  border-radius: 6px;

  font-weight: 600;
  font-style: normal;

  &:hover {
    box-shadow: 0 0 2.5pt 1.2pt $color-white-dark;
    transform: scale(1.02);
  }

  &__wrapper {
    display: flex;
    flex-direction: column;

    &__text {
      padding: 7px 16px;
      font-size: 12px;

      @include for-size(mobile) {
        font-size: 10px;
        padding: 4px 16px;
      }
    }

    &__note {
      background-color: $color-yellow-1;
      color: $color-yellow-7;
      padding: 0px 16px;
      border: 1px solid $color-yellow-7;
      border-radius: 0 0 5px 5px;
      font-size: 10px;
      height: 20px;
      display: flex;
      align-content: center;
      align-items: center;
      letter-spacing: -0.02em;
      justify-content: center;
      width: 100%;

      @include for-size(mobile) {
        font-size: 8px;
        padding: 0px 4px;
      }
    }
  }
}
</style>
